import { render, staticRenderFns } from "./BookingsArchive.vue?vue&type=template&id=f4b18140"
import script from "./BookingsArchive.vue?vue&type=script&lang=js"
export * from "./BookingsArchive.vue?vue&type=script&lang=js"
import style0 from "./BookingsArchive.vue?vue&type=style&index=0&id=f4b18140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports